const gutenbergAds = () => {

    let ads = document.querySelector('.content-side-left .entry-content .promo--inline-bottom');
    if( ads ) {
        let entryContent = document.querySelector('.content-side-left .entry-content');
        entryContent.insertBefore(ads, entryContent.children[6]);
    }

}

export default gutenbergAds;